import { InjectionToken } from '@angular/core';

export interface QuestionContext {
  showHints: boolean;
  optionsSelectable: boolean;
}

export const QUESTION_CONTEXT = new InjectionToken<QuestionContext>('QUESTION_CONTEXT');

export const DEFAULT_QUESTION_CONTEXT: QuestionContext = {
  showHints: true,
  optionsSelectable: true,
};
